import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Modal from "@/components/Modal.vue";
import StakeholdersEditor from "@/components/StakeholdersEditor.vue";
import ExternalConsultantsEditor from "@/components/ExternalConsultantsEditor.vue";
import ExternalSupportEditor from "@/components/ExternalSupportEditor.vue";
import InternsEditor from "@/components/InternsEditor.vue";
import UsersEditor from "@/components/UsersEditor.vue";
import EmployeesEditor from "@/components/EmployeesEditor.vue";
let UserSettings = class UserSettings extends Vue {
    getImpersonatableUsers() {
        try {
            return this.$store.dispatch("getMyTeamMembers");
        }
        catch (err) {
            return [];
        }
    }
    updateTeamManagerBenefit(item) {
        this.$store
            .dispatch("adminUpdateTeamManagerBenefit", {
            userId: this.$data.selectedUserData.userId,
            data: item,
        })
            .then((response) => {
            //this.loadEmployees();
            this.$data.modals.createNewTeamManagerBenefit = false;
            this.$data.modals.editUserSettings = false;
        })
            .catch((err) => {
            console.log("------------adminUpdateTeamManagerBenefit--------------");
            if (err.response) {
                this.$store.dispatch("ToastMessage", {
                    type: "error",
                    message: "Error when invoking adminUpdateTeamManagerBenefit: " + err,
                });
                console.log("Error when invoking adminUpdateTeamManagerBenefit: ", err.response);
                console.log("Error response:");
                console.log(err.response.data);
            }
            if (err.request) {
                console.log("Error request:");
                console.log(err.request);
            }
            else {
                console.log("Error when invoking adminUpdateTeamManagerBenefit: " + err);
                console.log("Error", err.message);
            }
            if (err.config !== undefined) {
                console.log("Error Config:");
                console.log(err.config);
            }
            console.log("------------------------------------------------");
        });
    }
    updateFixedBenefit(item) {
        this.$store
            .dispatch("adminUpdateFixedBenefitAsync", {
            userId: this.$data.selectedUserData.userId,
            data: item,
        })
            .then((response) => {
            //this.loadEmployees();
            this.$data.modals.createNewFixedBenefit = false;
            this.$data.loaders.createBenefitLoader = false;
            this.$data.modals.editUserSettings = false;
        })
            .catch((err) => {
            console.log("------------adminUpdateFixedBenefitAsync--------------");
            if (err.response) {
                this.$store.dispatch("ToastMessage", {
                    type: "error",
                    message: "Error when invoking adminUpdateFixedBenefitAsync: " + err,
                });
                console.log("Error when invoking adminUpdateFixedBenefitAsync: ", err.response);
                console.log("Error response:");
                console.log(err.response.data);
            }
            if (err.request) {
                console.log("Error request:");
                console.log(err.request);
            }
            else {
                console.log("Error when invoking adminUpdateFixedBenefitAsync: " + err);
                console.log("Error", err.message);
            }
            if (err.config !== undefined) {
                console.log("Error Config:");
                console.log(err.config);
            }
            console.log("------------------------------------------------");
        });
    }
    createNewFixedBenefit() {
        this.$data.loaders.createBenefitLoader = true;
        this.$store
            .dispatch("adminUpdateFixedBenefitAsync", {
            userId: this.$data.selectedUserData.userId,
            data: this.$data.createBenefit,
        })
            .then((response) => {
            //this.loadEmployees();
            this.$data.modals.createNewFixedBenefit = false;
            this.$data.loaders.createBenefitLoader = false;
            this.$data.modals.editUserSettings = false;
        })
            .catch((err) => {
            console.log("------------adminUpdateFixedBenefitAsync--------------");
            if (err.response) {
                this.$store.dispatch("ToastMessage", {
                    type: "error",
                    message: "Error when invoking adminUpdateFixedBenefitAsync: " + err,
                });
                console.log("Error when invoking adminUpdateFixedBenefitAsync: ", err.response);
                console.log("Error response:");
                console.log(err.response.data);
            }
            if (err.request) {
                console.log("Error request:");
                console.log(err.request);
            }
            else {
                console.log("Error when invoking adminUpdateFixedBenefitAsync: " + err);
                console.log("Error", err.message);
            }
            if (err.config !== undefined) {
                console.log("Error Config:");
                console.log(err.config);
            }
            console.log("------------------------------------------------");
        });
    }
    addFixedBenefitDialog() {
        this.$data.modals.createNewFixedBenefit = true;
    }
    addTeamManagerBenefitDialog() {
        this.$data.modals.createNewTeamManagerBenefit = true;
    }
    confirmDeleteOfFixedTariff(item) {
        this.$data.modals.confirmDeleteFixedBenefit = true;
        this.$data.selectedFixedBenefit = [item];
    }
    confirmDeleteOfTeamManagerBenefit(item) {
        this.$data.modals.confirmDeleteTeamManagerBenefit = true;
        this.$data.selectedTeamManagerBenefit = [item];
    }
    showEditModal(userItem) {
        //reset selections
        this.$data.selectedFixedBenefit = [];
        this.$data.selectedTeamManagerBenefit = [];
        this.$data.selectedLevel = [];
        this.$data.editEmployeeSelectedTab = 0;
        //open dialog
        this.$data.modals.editUserSettings = true;
        this.$data.selectedUserData = userItem;
        this.$data.selectedLevelIndex = null;
    }
    showTariffModal(userItem) {
        this.$store.dispatch("adminGetEmployeeTariffs", userItem.userId);
        this.$data.selectedUserData = userItem;
    }
};
UserSettings = __decorate([
    Component({
        data() {
            return {
                loading: false,
                employeeTypes: [
                    { text: "Prospect", value: "Prospect" },
                    { text: "Level", value: "Level" },
                    { text: "Fixed", value: "Fixed" },
                    { text: "TeamManager", value: "TeamManager" },
                ],
                selectedLevel: [],
                theme: this.$store.getters.getTheme,
                tariffFilter: "",
                missingTariffs: [],
                tariffTableLoading: false,
                editEmployeeSelectedTab: 0,
                isMobile: false,
                selectedUserData: null,
                loaders: {
                    removeFixedBenefit: false,
                },
                modals: {
                    editUserSettings: false,
                    tariffs: false,
                    addEmployee: false,
                    confirmDeleteFixedBenefit: false,
                    createNewFixedBenefit: false,
                    confirmDeleteTeamManagerBenefit: false,
                    createNewTeamManagerBenefit: false,
                    deleteUser: false,
                    addLevel: false,
                    confirmDeleteLevelUser: false,
                    addLevelSteps: 1,
                },
                employees: null,
                snakes: null,
                filter: "",
                tariffHeaders: [
                    { text: "Customer", value: "customerName" },
                    { text: "Name", value: "name" },
                    { text: "Delete", value: "delete" },
                ],
                levelHeaders: [
                    { text: "Name", value: "name" },
                    { text: "from", value: "from" },
                    { text: "", value: "delete" },
                ],
                fixedHeaders: [
                    { text: "Fixed Salary", value: "fixedSalary" },
                    { text: "From", value: "from" },
                    { text: "To", value: "to" },
                    { text: "", value: "delete" },
                ],
                employeeHeaders: [
                    { text: "Name", value: "email" },
                    { text: "Closed Reports", value: "closedReportsDate" },
                    { text: "Level Hours Left", value: "levelHoursLeft" },
                    { text: "Impersonate", value: "impersonate", sortable: false },
                    { text: "Edit", value: "edit", sortable: false },
                    { text: "Tariffs", value: "tariffs", sortable: false },
                    { text: "", value: "delete", sortable: false },
                ],
                snakeHeaders: [
                    { text: "Name", value: "email" },
                    { text: "End date", value: "endOfEmployment" },
                    { text: "Impersonate", value: "impersonate", sortable: false },
                    { text: "Edit", value: "edit", sortable: false },
                    { text: "Tariffs", value: "tariffs", sortable: false },
                ],
                selectedLevelIndex: null,
                impersonateText: "Impersonate",
                stakeholders: null,
                userTariffs: null,
                globalTariffs: null,
                selectedFixedBenefit: [],
                createBenefit: {
                    fixedSalary: 0,
                    pension: 0,
                    vacationDays: 0,
                    from: "",
                    to: null,
                },
                createTeamManagerBenefit: {
                    fixedSalary: 0,
                    pension: 0,
                    vacationDays: 0,
                    from: "",
                    to: null,
                    teamId: "",
                },
                selectedTeamManagerBenefit: [],
                createEmployee: {
                    employmentNumber: null,
                    email: "",
                    firstName: "",
                    lastName: "",
                    employmentDate: window.dateHandler.convertToUTCTime(new Date()),
                },
                adminLevels: null,
                levelToAdd: {
                    from: moment(new Date()).format("YYYY-MM-DD[T]00:00:00[Z]"),
                },
                levelToRemove: null,
                impersonatableUsersIds: null,
            };
        },
        computed: {},
        async mounted() {
            this.$data.impersonatableUsersIds = (await this.getImpersonatableUsers()).map((user) => user.userId);
            // loading the stakeholers list
            window.eventBus.$on("getStakeholderList", (obj) => {
                this.$data.stakeholders = obj;
            });
        },
        components: {
            IconBox,
            IconBoxContent,
            WhiteBox,
            Modal,
            StakeholdersEditor,
            ExternalConsultantsEditor,
            ExternalSupportEditor,
            InternsEditor,
            UsersEditor,
            EmployeesEditor,
        },
    })
], UserSettings);
export default UserSettings;
